'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        usePreset: {
            type: Boolean,
            default: true
        },
        networkList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        connection: {
            type: Object,
            default: function _default() {}
        }
    },
    data: function data() {
        return {
            name: '',
            presetNetworks: [],
            showCustom: true,
            willEmit: false
        };
    },
    computed: {
        presetServer: {
            set: function set(newVal) {
                if (newVal === 'custom') {
                    this.name = '';
                    this.connection.server = '';
                    this.connection.port = 6697;
                    this.connection.tls = true;

                    this.showCustom = true;
                } else {
                    var addr = this.parseFormatted(newVal);
                    this.name = addr.name;
                    this.connection.server = addr.server;
                    this.connection.port = addr.port;
                    this.connection.tls = addr.tls;

                    this.showCustom = false;
                }
            },
            get: function get() {
                return this.showCustom ? 'custom' : this.toUri(this.connection);
            }
        }
    },
    created: function created() {
        if (this.networkList) {
            this.importUris(this.networkList);
        }

        var con = this.connection;
        if (_lodash2.default.find(this.presetNetworks, function (s) {
            var match = s.server === con.server && s.port === con.port && s.tls === con.tls;
            return match;
        })) {
            this.showCustom = false;
        }
    },

    methods: {
        toUri: function toUri(s) {
            return s.server + ':' + (s.tls ? '+' : '') + s.port;
        },
        toggleTls: function toggleTls() {
            this.connection.tls = !this.connection.tls;

            if (this.connection.tls && this.connection.port === 6667) {
                this.connection.port = 6697;
            } else if (!this.connection.tls && this.connection.port === 6697) {
                this.connection.port = 6667;
            }
        },
        parseFormatted: function parseFormatted(input) {
            var ret = {
                name: '',
                server: '',
                port: 6667,
                tls: false
            };

            var val = input;

            var pipePos = val.indexOf('|');
            if (pipePos > -1) {
                ret.name = val.substr(0, pipePos);
                val = val.substr(pipePos + 1);
            }

            var colonPos = val.indexOf(':');
            if (colonPos === -1) {
                ret.server = val;
                val = '';
            } else {
                ret.server = val.substr(0, colonPos);
                val = val.substr(colonPos + 1);
            }

            if (val[0] === '+') {
                ret.tls = true;
                val = val.substr(1);
            }

            if (val.length > 0) {
                ret.port = parseInt(val, 10);
                val = '';
            }

            if (!ret.name) {
                ret.name = ret.server;
            }

            return ret;
        },
        importUris: function importUris(serverList) {
            var _this = this;

            var servers = serverList.map(function (s) {
                return _this.parseFormatted(s);
            });
            this.$set(this, 'presetNetworks', servers);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ServerSelector"]
window._kiwi_exports.components.ServerSelector = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ServerSelector.vue
// module id = kZ1f
// module chunks = 1